import { LOCAL_STORAGE } from 'constants/general';
import { t } from 'services/i18n.service';
import { useState } from 'react';
import { getLocalStorage, updateLocalStorage } from 'utils/helpers/storage';
import { v4 as uuid } from 'uuid';
import { capturePostHogEvent } from 'services/posthog.service';
import { useAppSelectorShallow } from 'store/hooks';
import { platformSelector } from 'store/reducer/setting/selectors';
import { BaseButtonXs } from 'components/ui/BaseButton';

interface ButtonExpressInterestProps {
  eventName: string;
  data?: Record<string, string | string[] | null>;
}

const ButtonExpressInterest = ({
  eventName,
  data = {}
}: ButtonExpressInterestProps) => {
  const { platform } = useAppSelectorShallow(platformSelector);
  const [resetKey, setResetKey] = useState(uuid());
  const eventData = data as { platform: string };
  const featureInterestResponses = getLocalStorage(
    LOCAL_STORAGE.FEATURES_EXPRESSED_INTEREST
  );

  const featuresExpressedInterest: { event: string; platform: string }[] =
    featureInterestResponses ? JSON.parse(featureInterestResponses) : [];

  const hasExpressedInterest = featuresExpressedInterest?.some(
    (feature) =>
      feature.event === eventName && feature.platform === eventData.platform
  );

  const handleClick = () => {
    capturePostHogEvent(eventName, { ...data, platform });
    const featureInterests = [
      ...featuresExpressedInterest,
      {
        event: eventName,
        platform
      }
    ];
    updateLocalStorage(
      LOCAL_STORAGE.FEATURES_EXPRESSED_INTEREST,
      JSON.stringify(featureInterests)
    );
    setResetKey(uuid());
  };

  if (hasExpressedInterest) {
    return null;
  }

  return (
    <BaseButtonXs
      key={resetKey}
      title={t('express_interest')}
      onClick={(event) => {
        event.stopPropagation();
        handleClick();
      }}
      variant='tertiary'
      additionalStyles='min-w-max py-0'
    />
  );
};

export default ButtonExpressInterest;
